import { render } from "./GuanWang.vue?vue&type=template&id=dd4eb206"
import script from "./GuanWang.vue?vue&type=script&lang=js"
export * from "./GuanWang.vue?vue&type=script&lang=js"

import exportComponent from "E:\\KaYu\\掌上推卡app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__